import { Component } from '@angular/core';
import { OrdersListComponent } from '../../../../components/admin-dashboard-component/orders/orders-list-component/orders-list-component';

@Component({
  selector: 'app-admin-orders',
  imports: [OrdersListComponent],
  templateUrl: './admin-orders.html',
  styleUrl: './admin-orders.scss',
})
export class AdminOrders {}
